import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../components/Button';
import TextField from '../TextField';
import Typography from '@material-ui/core/Typography';
import postalCodeRegex from '../../constants/postalCodeRegex';
import get from 'lodash/get';
import getGeocodedNormalizedAddress from '../../services/getGeocodedNormalizedAddress';
import { withRouter } from 'react-router-dom';
import analytics from '../../services/analytics';

const useStyles = makeStyles((theme) => {
  const {
    palette: { tenant },
  } = theme;
  return {
    zipInput: {
      marginBottom: 15,
    },
    crossSellBtn: {
      backgroundImage: `linear-gradient(to bottom, ${tenant.accent} 0%, ${tenant.accent} 50%, ${tenant.accentDark} 51%)`,
      '&:disabled': {
        backgroundImage: 'none',
        backgroundColor: tenant.mutedLight,
      },
    },
    getQuoteErrorMsg: {
      marginTop: 20,
      fontSize: 16,
    },
  };
});

function HeroGetQuoteInput({ history }) {
  const classes = useStyles();
  const [postalInput, setPostalInput] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const handleInputChange = ({ target: { value } }) => setPostalInput(value);
  const onClick = () => {
    analytics.ctaClicked();

    if (!postalCodeRegex.test(postalInput)) {
      setErrorMessage('invalidZip');
      return;
    }

    getGeocodedNormalizedAddress(postalInput)
      .then(({ region }) => {
        if (get(region, 'code') === 'SC') {
          history.push('/enroll');
        } else {
          setErrorMessage('notAvailable');
        }
      })
      .catch((e) => {
        setErrorMessage('notAvailable');
      });
  };

  return (
    <>
      <TextField
        value={postalInput}
        onChange={handleInputChange}
        label="Enter zip"
        margin="dense"
        variant="filled"
        fullWidth
        className={classes.zipInput}
        error={!!errorMessage}
        inputProps={{
          'data-testid': 'heroGetQuoteInput',
        }}
      />
      <Button
        className={classes.crossSellBtn}
        variant="tenant"
        data-testid="heroGetQuoteInput_cta"
        onClick={onClick}
      >
        Get a quote
      </Button>
      {!!errorMessage && (
        <Typography
          variant="caption"
          className={classes.getQuoteErrorMsg}
          paragraph={true}
          color="error"
          data-testid={
            errorMessage === 'notAvailable'
              ? 'heroGetQuoteInput_notAvailable'
              : 'heroGetQuoteInput_invalidZip'
          }
        >
          {errorMessage === 'notAvailable' ? (
            <>
              We are unable to provide you with a quote at this time.
              <br />
              Please call 1-800-FARMERS.
            </>
          ) : (
            'Please enter a valid zip code'
          )}
        </Typography>
      )}
    </>
  );
}

export default withRouter(HeroGetQuoteInput);
